<template>
  <div class="main jc-center">
    <div class="content">
      <div class="title">师资团队</div>
      <div class="swiper swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in list" :key="index">
            <img
              v-if="item && item.schoolPageInfo && item.schoolPageInfo.poster"
              :src="item.schoolPageInfo.poster"
            />
            <div
              v-if="item && item.schoolPageInfo && item.schoolPageInfo.poster"
              class="name"
            >
              {{ item.schoolPageInfo.title }}
            </div>
            <div
              v-if="item && item.schoolPageInfo && item.schoolPageInfo.summary"
              class="job"
            >
              {{ item.schoolPageInfo.summary }}
            </div>
            <div
              v-if="item && item.schoolPageInfo && item.schoolPageInfo.content"
              class="desc"
            >
              {{ item.schoolPageInfo.content }}
            </div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
    <!--    <div class="content">-->
    <!--      <div class="title">师资团队</div>-->
    <!--      <div class="swiper-container">-->
    <!--        <div class="swiper-wrapper">-->
    <!--          <div class="swiper-slide">-->
    <!--          </div>-->
    <!--        </div>-->

    <!--        <div class="swiper-pagination"></div>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>
<script>
// import Swiper from "swiper";
// import 'swiper/css/swiper.css'
export default {
  props: { info: Object },
  data() {
    return { list: [] };
  },
  watch: {
    info: {
      handler(val) {
        this.list = val.wxSchoolPageItemList;
      },
      deep: true,
    },
  },
  mounted() {
    this.list = this.info.wxSchoolPageItemList;
    this.$nextTick(() => {
      var swiper = new Swiper(".swiper-container", {
        loop: true,
        autoplay: {
          delay: 6500,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          320: {
            //当屏幕宽度大于等于320
            slidesPerView: 2,
            spaceBetween: 10,
          },
          768: {
            //当屏幕宽度大于等于768
            slidesPerView: 1,
            spaceBetween: 30,
          },
          1280: {
            //当屏幕宽度大于等于1280
            slidesPerView: 5,
            spaceBetween: 10,
          },
        },
      });
    });
  },
};
</script>
<style lang="less" scoped>
.main {
  background: #fafafa;
  padding-top: 48px;
  box-sizing: border-box;

  .content {
    width: 1200px;
    overflow: hidden;

    .title {
      padding-bottom: 40px;
      font-size: 32px;
      font-weight: 600;
      text-align: center;
    }

    .item {
      width: 227px;
      height: 440px;
      background: #fff;
    }

    .swiper-container {
      width: 100%;
      height: 100%;
      padding: 15px 55px !important;

      .swiper-slide {
        width: 220px !important;
        height: 440px;
        padding: 20px;
        box-sizing: border-box;
        background: #fff;
        margin-right: 16px;

        img {
          width: 185px;
          height: 185px;
        }

        .name {
          margin-top: 20px;
          font-size: 18px;
          font-weight: bolder;
          text-align: center;
        }

        .job {
          margin-bottom: 20px;
          color: #595959;
          text-align: center;
          font-size: 14px;
        }

        .desc {
          line-height: 1.8;
          color: #8c8c8c;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 5;
          overflow: hidden;
          font-size: 14px;
        }
      }
    }

    .btn {
      height: 40px;
      width: 20px;
      background-size: contain;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/designPage/template/banner/banner2/index.vue